<template>
  <div style="height: 100%; overflow-y: auto; padding: 20px">
    <table class="detail-tab" cellpadding="15">
      <tbody>
        <tr>
          <td>名称：</td>
          <td>{{ state.model.name }}</td>
        </tr>
        <tr>
          <td>状态：</td>
          <td :style="{ color: state.model.status == 0 ? '#f00' : '#1e90ff' }">
            {{ state.model.status == 0 ? "停用" : "正常" }}
          </td>
        </tr>
        <tr>
          <td>唯一识别码：</td>
          <td>{{ state.model.unified_social_credit_identifier }}</td>
        </tr>
        <tr>
          <td>所属行业：</td>
          <td>{{ state.model.d_industry_name }}</td>
        </tr>
        <tr>
          <td>所属地区：</td>
          <td>
            {{ state.model.province + state.model.city + state.model.district }}
          </td>
        </tr>
        <tr>
          <td>详细地址：</td>
          <td>{{ state.model.address || "-" }}</td>
        </tr>
        <tr>
          <td>对接人姓名：</td>
          <td>{{ state.model.contact_name || "-" }}</td>
        </tr>
        <tr>
          <td>职位：</td>
          <td>{{ state.model.contact_job || "-" }}</td>
        </tr>
        <tr>
          <td>联系方式：</td>
          <td>{{ state.model.contact_phone || "-" }}</td>
        </tr>
        <tr>
          <td>签单时间：</td>
          <td>{{ state.model.contract_time || "-" }}</td>
        </tr>
        <tr>
          <td>负责人：</td>
          <td>{{ state.model.belonger_name || "-" }}</td>
        </tr>
        <tr>
          <td>服务类型：</td>
          <td>{{ state.model.d_service_name || "-" }}</td>
        </tr>
        <!-- <tr>
          <td>发票类型：</td>
          <td>{{ state.model.name }}</td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customer_info } from "@/http/api";
export default {
  setup() {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      customer_info().then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    });
    return { state };
  },
};
</script>
<style scoped lang="less">
.detail-tab {
  & > tbody > tr > td:first-child {
    width: 200px;
  }
}
</style>
